import { ErrorInfo } from 'react'

import { GraphqlClient } from '@tribeplatform/gql-client/client'
import {
  ApiErrorCodes,
  ClientError,
  ErrorResponse,
} from '@tribeplatform/gql-client/lib'
import { AuthToken } from '@tribeplatform/gql-client/types'
import { getDomainInfo } from '@tribeplatform/react-components/common/utils'

// This will hold a loading state for different errors to make sure we are not pursuing the same error multiple times
let tokenRotationInProgress = false
const rotateAccessToken = async (
  client: GraphqlClient,
  domain: string,
  domainSubfolder: string,
) => {
  const { getResourceUrl } = getDomainInfo({
    domain,
    domainSubfolder,
  })

  if (tokenRotationInProgress) {
    return
  }

  try {
    tokenRotationInProgress = true
    const response = await fetch(getResourceUrl('/api/auth/refresh-token'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ domain }),
    })

    if (response.ok) {
      const data: AuthToken = await response.json()
      client.setToken(data.accessToken)
    }
  } catch (e) {
    logger.warn('Could not update the access token on global error handler', e)
  } finally {
    tokenRotationInProgress = false
  }
}

export const onClientError = (
  errors: ErrorResponse[],
  client: GraphqlClient,
  domain: string,
  domainSubfolder: string,
  _error?: ClientError,
) => {
  const isInvalidToken =
    Array.isArray(errors) &&
    errors?.some(e => e?.code === ApiErrorCodes.INVALID_ACCESS_TOKEN)

  if (isInvalidToken) {
    rotateAccessToken(client, domain, domainSubfolder)
  }
}

export const errorBoundaryHandler = (error: Error, errorInfo: ErrorInfo) => {
  logger.error(error, errorInfo)
}
